import actions from './actions'
import mutations from './mutations'
import getters from './getters'

let state = {
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/contacts/index.js